<template>
  <div class="column is-12">
    <b-field
      label="Status"
      horizontal
      :type="active ? 'is-info' : ''"
      :custom-class="active ? 'has-text-info' : ''"
    >
      <b-select
        name="order_status"
        expanded
        size="is-small"
        :value="value"
        @input="onInput"
      >
        <option value>All</option>
        <optgroup label="Status Groups">
          <option
            v-for="(option, index) in options.groups"
            :value="option.value"
            :key="index"
          >
            {{ option.text }}
          </option>
        </optgroup>
        <optgroup label="Individual States">
          <option
            v-for="(option, index) in options.statuses"
            :value="option.value"
            :key="index"
          >
            {{ option.text }} - {{ option.value[0] }}
          </option>
        </optgroup>
      </b-select>
    </b-field>
  </div>
</template>

<script>
import { statusGroups, statuses } from "@/helpers/statuses";

export default {
  props: {
    value: {
      type: String | Array
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: {
      groups: [],
      statuses: []
    }
  }),
  created() {
    // Use central storage(?) for statuses
    this.options.groups = Object.keys(statusGroups).reduce((acc, key) => {
      acc.push({ value: statusGroups[key], text: key });
      return acc;
    }, []);
    this.options.statuses = Object.keys(statuses).reduce((acc, key) => {
      acc.push({ value: [key], text: statuses[key] });
      return acc;
    }, []);
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
      this.$emit("update:value", value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/Field/OrderFilterFieldStatus.vue